// extracted by mini-css-extract-plugin
export default {"titleInput":"general-information-section_titleInput__x7Rbq","error":"general-information-section_error__apvD2"};